import { Configuration } from '../app.constants'
import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'

@Injectable()
export class StoreUserService {
    constructor(private http: HttpClient) {
    }

    getList(): any {
        //console.log(Configuration.apiUrl + 'Api/Transactions/GetTransactionsList?month=' + month + '&year=' + year + '&initialDate=&lastDate=')
        return this.http.get(Configuration.apiUrl + 'Api/StoreUser/List')
    }
}